export default __webpack_public_path__ + "static/media/bg_ip_02.dfcb83349e5601fb372f825f49f3d1cc.svg";